import Cookies from "js-cookie";

export function getAdminAuthHeaders() {
  const token = Cookies.get("userToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** Let axios set multipart boundary automatically � never set Content-Type manually */
export function getAdminUploadHeaders() {
  return getAdminAuthHeaders();
}

export function appendColors(formData, colors) {
  colors.forEach((color) => formData.append("color", color));
}

export function appendImages(formData, images, fieldName = "images") {
  images.forEach((image) => formData.append(fieldName, image));
}

export function appendKeepImages(formData, imageUrls, fieldName = "keepImages") {
  imageUrls.forEach((url) => formData.append(fieldName, url));
}

export function normalizeCategoryId(categoryId) {
  if (!categoryId) return "";
  if (typeof categoryId === "string" && categoryId.includes("[object")) return "";
  if (typeof categoryId === "object" && categoryId._id) {
    return categoryId._id.toString?.() ?? String(categoryId._id);
  }
  return String(categoryId).trim();
}

export function getApiErrorMessage(error, fallback = "Request failed") {
  if (!error?.response) {
    return error?.message?.includes("Network Error")
      ? "Cannot reach server. Check your connection."
      : fallback;
  }
  const data = error.response.data;
  if (typeof data === "string" && !data.includes("<!DOCTYPE")) return data;
  return data?.error || data?.message || data?.alert || fallback;
}

export function ensureAdminAuth() {
  const headers = getAdminAuthHeaders();
  if (!headers.Authorization) {
    throw new Error("Admin session expired. Please log in again.");
  }
  return headers;
}
